module.exports = __webpack_public_path__ + "static/img/stage-3.67631ebb.png";